'use client';

export { default } from '@/components/fallback/ErrorState';
